import styled from "@emotion/styled/macro";


const Title = styled.div`
  font-family: Avenir;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 33px;
  /* identical to box height */

  text-align: center;

`;

export const VideoTitle = styled.span`

  font-family: Avenir;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  margin: 0 16px;

  /* Action/Active */

  color: rgba(0, 0, 0, 0.54);

`
export default Title;